import mdl from '@/models/Accounting/AccAccountingSeatConcept'

const getAllConcepts = async () => {
    try {
        let response = await mdl.params({ get_all_results: true }).get()
        return response
    } catch (error) {
        return error.response
    }
}

export { getAllConcepts }
